import { FilterButtonsProps } from "components/Explore/FilterButtons";
import { useState } from "react";
import { EMessageType } from "types/Message.type";
import FilterCapsules from "./filters/capsules/filterCapsules";
import SelectExplore from "./selectExplore";

export default function SectionFilterSearchExplore(props: FilterButtonsProps) {
  const [value, setValue] = useState("");
  const isRenderFilterCapsules = value === EMessageType.CAPSULES.toLowerCase();

  return (
    <>
      <SelectExplore {...props} isCompresed value={value} setValue={setValue} />
      <FilterCapsules {...props} render={isRenderFilterCapsules} />
    </>
  );
}
